import { IApplicationState } from '../../types/redux';

export const getReviewsStat = (state: IApplicationState) => {
  return state.newbuilding.reviews;
};
